import styled from 'styled-components';

export const Content = styled.div`
  padding: 15px;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: visible;
  color: #e6eaec;
`;
export const Center = styled.div`
  text-align: center;
  padding: 80px 0;
  color: #aab2b8;
`;

export const Nominal = styled.div`
  img {
    margin-top: 3px;
    margin-right: 2px;
  }
  span {
    display: inline-block;
    vertical-align: top;
    min-width: 45px;
    text-align: center;
  }
`;
export const NominalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 2px;
  i {
    margin-left: 5px;
  }
`;
export const CashTable = styled.table`
  margin: 0 auto 25px;
  &:last-child {
    margin-bottom: 0;
  }
  border-collapse: collapse;
  table-layout: fixed;
  //width: 950px;
  color: #e6eaec;
  font-size: 15px;
  border-style: hidden;
  .warning-medium {
    color: #d4a017;
  }
  .warning-hight {
    color: #cc2936;
  }
  .warn {
    position: absolute;
    right: 2px;
    top: 50%;
    margin-top: -6px;
    width: 12px;
    height: 12px;
  }
  .warn-mid {
    color: #d4a017;
  }
  .warn-high {
    color: #cc2936;
  }
  p {
    font-size: 13px;
    color: #e6eaec;
  }
  .bill,
  .coin {
    display: block;
    //position: absolute;
    //left: 0;
    //top: 50%;
    //margin-top: -14px;
    width: 25px;
    height: 23px;
    margin-right: 5px;
    background: url(/images/coin2.png) no-repeat 2px 50%;
    background-size: contain;
  }
  .bill {
    background-image: url(/images/bill2.png);
  }
  td,
  th {
    position: relative;

    width: 120px;
    min-width: 120px;
    padding: 0 1px;
    text-align: center;
    height: 25px;
    border: 1px solid #2c353d;
    &:first-child {
      text-align: right;
    }
  }
  th {
    background-color: #161e23;
    color: #aab2b8;
    font-weight: 600;
    &:first-child {
      background-color: rgba(0, 0, 0, 0) !important;
    }
    &:nth-child(even) {
      background-color: #12171c;
    }
    &.gray {
      background-color: #1a2429 !important;
      color: #e6eaec;
    }
    &.disabled {
      position: relative;
      &::after {
        content: '${(props) => props.$status}';
        position: absolute;
        top: 102%;
        left: 0;
        width: 100%;
        font-size: 13px;
        font-weight: normal;
        color: #cc2936;
        text-align: center;
        text-transform: capitalize;
      }
    }
  }
  td {
    &:nth-child(even) {
      background-color: #12171c;
    }
    &:first-child {
      vertical-align: text-top;
      text-align: right;
      padding-top: 5px;
      padding-left: 0;
      border-bottom: 0;
      color: #aab2b8;
    }
  }
`;

export const InfoHeader = styled.div`
  font-size: 14px;
  color: #47b972;
  padding-bottom: 10px;
  margin-left: 17px;
  margin-bottom: 15px;
`;
